<template>
    <div class="pb-5">
        <data-table ref="questions"
                    :api-route="backendApiRoute"
                    :api-view-set="table.apiViewSet"
                    :name="table.name"
                    :columns="table.columns"
                    :search="table.search"
                    :filters="table.filters ? table.filters : []"
                    :actions="table.actions"
                    :orderings="table.orderings"
                    :initial-orderings="table.initialOrderings"
                    :row-actions="table.rowActions"
                    :key="table.key">
        </data-table>
    </div>
</template>

<script>
import DataTable from "@/components/Table/DataTable";
import {mapGetters} from "vuex";
import api from "@/api";
import actions from "@/components/Table/actions";
import {Municipality} from "@/pages/AppPages/Catalogs/Municipality/municipality";
import {Breed} from "@/pages/AppPages/Catalogs/Animals/breed";
import {News} from "@/pages/AppPages/News/news";
import {Question} from "@/pages/AppPages/Catalogs/FAQ/question";
export default {
    name: "QuestionList",
    components: {DataTable},
    computed: {
        ...mapGetters(['ability']),
        backendApiRoute() { return api.questions.default.list() },
    },
    data() {
        return {
            table: {
                name: 'questions-table',
                apiViewSet: api.questions.default,
                key: 'questions-table',
                search: true,
                columns: [
                    { name: 'group_object.name', 'title': 'Тематика'},
                    {
                        name: 'text',
                        title:  'Вопрос',
                        alwaysVisible: true,
                        to: {
                            idColumn: 'id',
                            routeName: 'questionDetail',
                            prependWithN: false
                        }
                    },
                    { name: 'publish', 'title': 'Публиковать', cellComponentName: 'BooleanCell',
                        cellComponentPath: 'src/pages/DataTableCells/'},
                    { name: 'list_order', 'title': 'Порядок'},
                    { name: 'has_files', 'title': 'Файлы',
                            extraProps: {iconYes: 'file-earmark-richtext', iconNo: null, iconYesColor: 'info', iconNoColor: null},
                            cellComponentName: 'BooleanCell',
                            cellComponentPath: 'src/pages/DataTableCells/'},
                ],
                orderings: [
                    'list_order',
                    'publish',
                    'text',
                    { 'has_files': 'files_count' },
                    { 'group_object.name': 'group__name' }
                ],
                actions: [],
                rowActions: [],
                filters: []
            }
        }
    },
    mounted() {
        this.table.actions.push(
            actions.create(() => {
                    this.$router.push({name: 'questionCreate'})
                }, this.ability.can('create', 'Question')
            )
        );

        if (this.ability.can('destroy', 'Question')) {
            this.table.rowActions.push(
                new actions.objectDelete(Question))
        }

    }

}
</script>

<style scoped>

</style>